import { ReactNode } from "react";
import { View } from "./View";

export interface TopDownFlexedProps {
  key_id: ReactNode;
  value: ReactNode;
}

export const LeftRightFlexedContainer = (props: TopDownFlexedProps) => {
  return <View {...props} />;
};
